import exportPortalAPI from '@/apis/other/exporPortaltAPI.js'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('Grade', exportPortalAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
  },
  mutations: {
    ...crudBase.mutations,
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,

    /**
   * @author PVThang
   * @param {*} param0
   * @param {*} payload
   * @returns Downnload file mẫu
   */
    async generateTemplate ({ commit }, payload) {
      const res = await exportPortalAPI.generateTemplate(payload || {})

      if (res) {
        commit('setItems', res)
      }

      return res
    },
  },
}
